import React from 'react';

// "Follow us" strip — sits just below the hero on the landing page.
// Icons use `currentColor` so hover color changes apply cleanly to the SVG
// (not as a background square). LinkedIn is shown only when its URL is set.

const LINKEDIN_URL = 'https://linkedin.com/company/ascendforyou';

const SocialStrip = () => (
  <section className="py-10 border-b border-[#e5e7eb] bg-white" data-testid="social-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-center gap-6">
      <span className="text-sm uppercase tracking-[0.2em] font-semibold text-[#6b7280]">
        Follow us for weekly ATS &amp; career tips
      </span>
      <div className="flex items-center gap-5">
        <a
          href="https://x.com/AscendForYou"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Follow Ascend on X"
          data-testid="social-strip-x"
          className="text-[#4b5563] hover:text-[#0f1115] transition-colors hover:scale-110 transition-transform"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61567607631360"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Follow Ascend on Facebook"
          data-testid="social-strip-facebook"
          className="text-[#4b5563] hover:text-[#1877F2] transition-colors hover:scale-110 transition-transform"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
        </a>
        {LINKEDIN_URL && (
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Ascend on LinkedIn"
            data-testid="social-strip-linkedin"
            className="text-[#4b5563] hover:text-[#0A66C2] transition-colors hover:scale-110 transition-transform"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        )}
      </div>
    </div>
  </section>
);

export default SocialStrip;
